/*
 * Copyright 2021 LABOR.digital
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Last modified: 2021.08.28 at 15:18
 */
var BinderContext = /** @class */ (function () {
    function BinderContext(bit, binder, proxy) {
        this.bit = bit;
        this.binder = binder;
        this.proxy = proxy;
    }
    Object.defineProperty(BinderContext.prototype, "bitContext", {
        /**
         * The context object of the BIT class
         */
        get: function () {
            return this.bit.$context;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Used to destroy the context object - Internal only
     * @internal
     */
    BinderContext.prototype.destroy = function () {
        this.proxy.destroy();
        this.bit = null;
        this.binder = null;
        this.proxy = null;
        this.pullableProperties = null;
    };
    return BinderContext;
}());
export { BinderContext };
//# sourceMappingURL=BinderContext.js.map